import "./Datatable.css";
import { DataGrid } from "@mui/x-data-grid";
import { userColumns } from "../../datatablesource";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";

// Import des icônes
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";

const Datatable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get("http://localhost:5000/api/auth/users");
        
        // Ajouter l'ID Firebase à chaque utilisateur
        const usersWithSequentialIds = response.data.map((user, index) => ({
          ...user,
          id: index + 1, // ID séquentiel pour l'affichage
          firebaseId: user.id, // Ajout de l'ID Firebase réel
        }));
  
        setData(usersWithSequentialIds);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching users:", err);
        setError("Erreur lors de la récupération des utilisateurs.");
        setLoading(false);
      }
    };
  
    fetchUsers();
  }, []);
  
  const handleDelete = async (userId) => {
    try {
      // Trouver l'utilisateur réel avec l'ID Firebase
      const userToDelete = data.find((user) => user.id === userId); // Trouver l'utilisateur avec l'ID séquentiel
      if (userToDelete) {
        const firebaseId = userToDelete.firebaseId; // Assurez-vous que 'firebaseId' est l'ID Firebase réel
  
        // Effectuer la requête DELETE avec l'ID Firebase
        const response = await axios.delete(`http://localhost:5000/api/auth/delete/${firebaseId}`);
        alert('Utilisateur supprimé avec succès!');
  
        // Rafraîchir les données après la suppression
        setData(data.filter((user) => user.id !== userId));
      }
    } catch (error) {
      console.error('Erreur lors de la suppression de l\'utilisateur :', error);
      alert('Erreur lors de la suppression de l\'utilisateur.');
    }
  };
  
  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            {/* Icône pour "Voir" */}
            <Link to={`/admin/users/${params.row.id}`} style={{ textDecoration: "none" }}>
              <VisibilityIcon
                className="viewIcon"
                style={{ color: "#9caf7d", cursor: "pointer", marginRight: "10px" }}
                titleAccess="Voir"
              />
            </Link>

            {/* Icône pour "Supprimer" */}
            <DeleteIcon
              className="deleteIcon"
              style={{ color: "#d32f2f", cursor: "pointer" }}
              titleAccess="Supprimer"
              onClick={() => handleDelete(params.row.id)}
            />
          </div>
        );
      },
    },
  ];

  if (loading) {
    return <div>Chargement des utilisateurs...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="datatable">
      <div className="datatableTitle">
        Ajouter un nouvel utilisateur
        <Link to="/admin/users/new" className="link">
          Ajouter
        </Link>
      </div>
      <DataGrid
        className="datagrid"
        rows={data}
        columns={userColumns.concat(actionColumn)}
        pageSize={9}
        rowsPerPageOptions={[9]}
        checkboxSelection
        getRowId={(row) => row.id}
      />
    </div>
  );
};

export default Datatable;
